import * as trackActions from '../../pages/track/trackActions'
import * as albumActions from '../../pages/album/albumActions'
import * as artistActions from '../../pages/artist/artistActions'
import * as playlistActions from '../../pages/playlist/playlistActions'
import * as focusActions from '../../pages/focus/focusActions'

const loadingInit = false
export const loading = (state = loadingInit, action) => {
	switch (action.type) {
		case trackActions.GET_TRACK_REQUEST:
		case albumActions.GET_ALBUM_REQUEST:
		case artistActions.GET_ARTIST_REQUEST:
		case playlistActions.GET_PLAYLIST_REQUEST:
		case focusActions.GET_FOCUS_REQUEST:
			return true
		case trackActions.GET_TRACK_SUCCESS:
		case albumActions.GET_ALBUM_SUCCESS:
		case artistActions.GET_ARTIST_SUCCESS:
		case playlistActions.GET_PLAYLIST_SUCCESS:
		case focusActions.GET_FOCUS_SUCCESS:
			return false
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/components/loader/loaderReducer.js